<template>
  <fieldset id="map-bottom-popup-swiper" v-if="relicImgList.imgList[0]">
    <legend>{{ relicImgList.type }}</legend>
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, index) in relicImgList.imgList" :key="index"
        ><img
          class="img-item"
          :src="item.url"
          alt=""
          @click="handlePreview(item.url)"
      /></swiper-slide>
    </swiper>
    <el-image
      v-if="type === 0"
      id="preview-img"
      style="width: 1px; height: 1px;"
      :src="previewPhoto"
      :preview-src-list="previewPhotoList"
    ></el-image>
    <el-image
      v-if="type === 1"
      id="preview-draw"
      style="width: 1px; height: 1px;"
      :src="previewDraw"
      :preview-src-list="previewDrawList"
    ></el-image>

    <el-image
      v-if="type === 2"
      id="preview-point"
      style="width: 1px; height: 1px;"
      :src="previewPoint"
      :preview-src-list="previewPointList"
    ></el-image>
  </fieldset>
</template>

<script>
import 'swiper/swiper-bundle.css';
// 按需引入swiper，及其函数
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    relicImg: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Number
    }
  },
  watch: {
    relicImg: {
      immediate: true,
      handler() {
        this.relicImgList = this.relicImg;
        if (this.type === 0) {
          this.previewPhoto = this.relicImgList?.imgList[0]?.url;
          this.relicImgList?.imgList.forEach(item => {
            this.previewPhotoList.push(item.url);
          });
        } else if (this.type === 1) {
          this.previewDraw = this.relicImgList?.imgList[0]?.url;
          this.relicImgList?.imgList.forEach(item => {
            this.previewDrawList.push(item.url);
          });
        } else {
          this.previewPoint = this.relicImgList?.imgList[0]?.url;
          this.relicImgList?.imgList.forEach(item => {
            this.previewPointList.push(item.url);
          });
        }
      }
    }
  },
  data() {
    return {
      previewPhotoList: [],
      previewDrawList: [],
      previewPointList: [],
      relicImgList: {},
      swiperOptions: {
        slidesPerView: 'auto',
        observer: true,
        spaceBetween: 20,
        observerParent: true
      },
      previewPhoto: '',
      previewDraw: '',
      previewPoint: ''
    };
  },
  methods: {
    handlePreview(url) {
      if (this.type === 0) {
        const imgBtn = document.getElementById('preview-img');
        this.previewPhoto = url;
        imgBtn.click();
      } else if (this.type === 1) {
        const imgBtn = document.getElementById('preview-draw');
        this.previewDraw = url;
        imgBtn.click();
      } else {
        const imgBtn = document.getElementById('preview-point');
        this.previewPoint = url;
        imgBtn.click();
      }
    }
  }
};
</script>

<style lang="scss">
#map-bottom-popup-swiper {
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid $color-border-light;
  .swiper-container {
    width: calc(100vw - 76px);
    height: 300px;
  }
  .swiper-slide {
    display: flex;
    justify-content: center;
    width: auto;
    height: 300px;
  }
  .img-item {
    width: auto;
    height: 300px;
    border-radius: 8px;
    // object-fit: contain;
  }
  #preview-img {
    opacity: 0 !important;
    position: absolute;
    z-index: -2000;
  }
  // .el-image {
  //   opacity: 0 !important;
  //   position: absolute;
  //   z-index: -2000;
  // }
  #preview-draw {
    opacity: 0;
    position: absolute;
    z-index: -1000;
  }
}
</style>
